import React, { useState } from 'react';
import { Link } from 'gatsby';

import Logo from '@components/logo';
import activities from '@data/navigation.json';
import s from '@styles/header.module.css';
import { cx } from '@utils';

const Header = () => {
  const [navOpen, setNavOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  function toggleNav() {
    setNavOpen(prev => {
      if (!prev) setDropdownOpen(true);
      return !prev;
    });
  }

  function hideNav() {
    setNavOpen(false);
  }

  function toggleDropdown(e) {
    e.preventDefault();
    setDropdownOpen(prev => !prev);
  }

  return (
    <header className="header-nav container-fluid">
      <nav className="navbar navbar-expand-md container">
        <Link className="navbar-brand" to="/" aria-label="Keso-Promet, početna stranica">
          <Logo />
        </Link>
        <div className={cx('collapse navbar-collapse', navOpen && 'show')}>
          <ul className="navbar-nav" role="menubar">
            <li className="nav-item" role="none">
              <Link to="/#about" className="nav-link" onClick={hideNav} role="menuitem">
                O nama
              </Link>
            </li>
            <li className="nav-item nav-dropdown" role="none">
              <Link
                to="/"
                className="nav-link"
                onClick={toggleDropdown}
                role="button"
                aria-expanded={dropdownOpen}
                aria-haspopup="true"
              >
                Djelatnosti
                <span className={cx('icon-chevron-down', dropdownOpen && 'rotate')}></span>
              </Link>
              <div className={cx('dropdown-menu', dropdownOpen && 'show')} role="menu">
                {activities.map(item => (
                  <Link to={item.to} className="dropdown-item" role="menuitem" key={item.to}>
                    {item.label}
                  </Link>
                ))}
              </div>
            </li>
            <li className="nav-item" role="none">
              <Link to="/#contact" className="nav-link" onClick={hideNav} role="menuitem">
                Kontakt
              </Link>
            </li>
          </ul>
        </div>
        <button
          className={cx(s.menu, 'navbar-toggler', navOpen && 'open-fixed')}
          type="button"
          onClick={toggleNav}
          aria-label="Meni"
          aria-expanded={navOpen}
        >
          <span className={s.menu__box}>
            <span className={s.menu__inner}></span>
          </span>
        </button>
      </nav>
    </header>
  );
};

export default Header;
